import React from "react";

import ProjectHero from "./Hero/projectHero";
import ProjectsList from "./ProjectList/projectList";

const Projects = () => {
  return (
    <div>
      <ProjectHero />
      <ProjectsList />
    </div>
  );
};

export default Projects;
